import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../shared/auth.service";
import { IDLE_LOGOUT_FLAG } from "../../shared/idle.service";
import { SESSION_EXPIRED_FLAG } from "../../shared/app-auth-guards";

@Component({
    selector: "cal-login",
    standalone: true,
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
    returnUrl = "/dashboard";
    idleLogout = false;
    sessionExpired = false;

    constructor(
        private authService: AuthService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.returnUrl = this.route.snapshot.queryParamMap.get("returnUrl") || "/dashboard";
        this.idleLogout = sessionStorage.getItem(IDLE_LOGOUT_FLAG) === "1";
        this.sessionExpired = sessionStorage.getItem(SESSION_EXPIRED_FLAG) === "1";
        sessionStorage.removeItem(IDLE_LOGOUT_FLAG);
        // A cached account whose tokens could not be renewed must not bounce back to the app.
        if (this.authService.isLoggedIn() && !this.sessionExpired) {
            this.router.navigateByUrl(this.returnUrl);
        }
    }

    signIn(): void {
        sessionStorage.removeItem(SESSION_EXPIRED_FLAG);
        this.authService.login(this.returnUrl);
    }
}
